/**
 * Theme preference for THEG MARKET PLACE.
 * Persists via localStorage; applied as data-theme on <html>.
 */
import type { ThemeName } from '../types';

const STORAGE_KEY = 'theg_theme';
const DEFAULT_THEME: ThemeName = 'lemon';
export const THEMES = Object.freeze(['lemon', 'ink'] as const);

function normalize(theme: string | null | undefined): ThemeName {
  const t = String(theme || '').toLowerCase();
  return (THEMES as readonly string[]).includes(t) ? (t as ThemeName) : DEFAULT_THEME;
}

export function getTheme(): ThemeName {
  try {
    return normalize(localStorage.getItem(STORAGE_KEY));
  } catch {
    return DEFAULT_THEME;
  }
}

export function setTheme(theme: string): ThemeName {
  const next = normalize(theme);
  try {
    localStorage.setItem(STORAGE_KEY, next);
  } catch {
    /* ignore quota / private mode */
  }
  document.documentElement.setAttribute('data-theme', next);
  return next;
}

/** Apply stored theme as early as possible (also call from main). */
export function initTheme(): ThemeName {
  return setTheme(getTheme());
}
